import React from 'react';
import ParticleBackground from './components/three/ParticleBackground';
import NavBar from './components/NavBar';
import CustomCursor from './components/CustomCursor';
import Hero from './sections/Hero';
import About from './sections/About';
import Experience from './sections/Experience';
import Skills from './sections/Skills';
import Projects from './sections/Projects';
import Contact from './sections/Contact';
import './index.css';

function App() {
  return (
    <>
      <CustomCursor />
      <ParticleBackground />
      <NavBar />
      <main>
        <Hero />
        <About />
        <Experience />
        <Skills />
        <Projects />
        <Contact />
      </main>
      <footer className="footer">
        Built with React &amp; Three.js · Harsh Singh 2025
      </footer>
    </>
  );
}

export default App;
